let updateAvailable = false
const listeners = new Set()

export function subscribeToAppUpdate(callback) {
  listeners.add(callback)
  callback(updateAvailable)
  return () => listeners.delete(callback)
}

export function notifyUpdateAvailable() {
  if (updateAvailable) return
  updateAvailable = true
  listeners.forEach((listener) => listener(true))
}

export function refreshApp() {
  window.location.reload()
}
